// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3zXxB","info":"PatientInfo_info__33SoB"};